/** @format */
import { useContext, useEffect, useState } from 'react';

import { MarketContext } from '@toucan/client/global/market';

import {
    PageData,
    QueryVariables,
    getPageData,
} from '@toucan/client/core/contentful';

import { useMounted } from '@toucan/client/shared/hooks/use-mounted';

type QueryVariablesWithoutLocale = Omit<QueryVariables, 'locale'>;

export function usePageData<V = QueryVariablesWithoutLocale>(
    queryVariables: V & QueryVariablesWithoutLocale,
    fallbackContent?: PageData
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
): { pageData: PageData; loading: boolean } {
    const { activeMarket } = useContext(MarketContext);
    const [pageData, setPageData] = useState<PageData>({});
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const [loading, setLoading] = useState(true);

    const isMounted = useMounted();

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Legacy code: do not use as an example.
        (async () => {
            try {
                const contentfulResponse = await getPageData<V>({
                    ...queryVariables,
                    locale: activeMarket.iso,
                });

                // component has been unmounted since we made the request
                if (!isMounted()) {
                    return;
                }

                setPageData(contentfulResponse);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
            } catch (error) {
                // set fallback content if available
                if (fallbackContent && isMounted()) {
                    setPageData(fallbackContent);
                }
            }
            setLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, []);

    return { pageData, loading };
}
